var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useContext } from 'react';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import withCssProps from '../../hocs/withCssProps';
import { Ilocation } from '../../atoms/AgroIcon/icons';
import styled, { createGlobalStyle } from 'styled-components';
import { AgroLocationWeatherModal } from '../../molecules/AgroLocationWeatherModal';
import { confirmAddress, isAddressConfirmed } from '../../services/userAddress';
import { Text } from '../../atoms/Text';
var WeatherFieldZone = withCssProps(function (_ref) {
  var address = _ref.address,
    isLogged = _ref.isLogged,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'es-AR' : _ref$language,
    apiGateway = _ref.apiGateway,
    changeLocation = _ref.changeLocation,
    popoverDisabled = _ref.popoverDisabled,
    isDifferentAddress = _ref.isDifferentAddress,
    tagManager = _ref.tagManager,
    pageId = _ref.pageId,
    ctaCurrentLocationLabelModal = _ref.ctaCurrentLocationLabelModal,
    openLocationModal = _ref.openLocationModal,
    onCloseLocationModal = _ref.onCloseLocationModal,
    userAddressLoaded = _ref.userAddressLoaded;
  var _useContext = useContext(AgroHeaderContext),
    baseUrl = _useContext.baseUrl,
    marketUrl = _useContext.marketUrl,
    loginUrlRedirect = _useContext.loginUrlRedirect,
    translations = _useContext.translations,
    categoryId = _useContext.categoryId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPopover = _useState4[0],
    setShowPopover = _useState4[1];
  var loginURL = "".concat(marketUrl, "/auth?urlRedirect=").concat(loginUrlRedirect || baseUrl, "?login=redirect").concat(categoryId ? "&category=".concat(categoryId) : '');
  useEffect(function () {
    if (openLocationModal.value == true) {
      openModal();
    }
  }, [openLocationModal]);
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  useEffect(function () {
    if (isDifferentAddress != undefined) {
      var params = new URLSearchParams(window.location.search);
      if (params.has('login') && (isLogged && userAddressLoaded && !address || address !== null && address !== void 0 && address.userAddressWasEmpty)) {
        //Delete params to prevent re-open modal
        window.history.replaceState(null, '', window.location.pathname);
        openModal();
      } else if (!popoverDisabled && (isAddressConfirmed() !== 'true' && !address || isDifferentAddress && isLogged || address !== null && address !== void 0 && address.userAddressWasEmpty && isLogged)) {
        var gtmEvent = {
          dataLayer: {
            event: 'modal_impression',
            modal_type: 'geolocation_popover'
          }
        };
        if (tagManager) {
          tagManager(gtmEvent);
        }
        //setShowPopover(true);
      }
    }
  }, [address === null || address === void 0 ? void 0 : address.userAddressWasEmpty, isDifferentAddress, userAddressLoaded]);
  var closePopover = function closePopover() {
    setTimeout(function () {
      setShowPopover(false);
    }, 8000);
  };
  useEffect(function () {
    if (pageId) {
      var _handleScroll = function handleScroll() {
        document.getElementById(pageId).removeEventListener('scroll', _handleScroll);
        closePopover();
      };
      document.getElementById(pageId).addEventListener('scroll', _handleScroll);
    } else {
      var _handleScroll2 = function handleScroll() {
        window.removeEventListener('scroll', _handleScroll2);
        closePopover();
      };
      window.addEventListener('scroll', _handleScroll2);
    }
  }, []);
  var _onLogin = function onLogin() {
    if (window && window.location) {
      window.location.href = loginURL;
    }
  };
  var _onClose = function onClose() {
    setTimeout(function () {
      toggleModal(false);
      onCloseLocationModal();
    }, 0);
  };
  var _onChangeLocation = function onChangeLocation(newAddress) {
    changeLocation(newAddress);
    //Algo algo, cookies de confirmacion
    confirmAddress();
    toggleModal(false);
    //setShowPopover(false);
  };
  var openModal = function openModal() {
    if (isLogged && (address === null || address === void 0 ? void 0 : address.type) === 'saved') {
      var weatherUrl = language === 'pt-BR' ? '/previsao-clima-tempo' : '/pronostico-clima-tiempo';
      window.location.href = weatherUrl;
      return;
    }
    setTimeout(function () {
      //setShowPopover(false);
      toggleModal(true);
    }, 0);
  };
  var toggleModal = function toggleModal(show) {
    if (show) {
      var gtmEvent = {
        dataLayer: {
          event: 'modal_impression',
          modal_type: 'geolocation_modal'
        }
      };
      if (tagManager) {
        tagManager(gtmEvent);
      }
    }
    setShowModal(show);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showModal && /*#__PURE__*/React.createElement(ScrollLock, null), /*#__PURE__*/React.createElement(ShippingAreaContainer, {
    onClick: openModal
  }, !!address && address.City && address.State ? /*#__PURE__*/React.createElement(ShippingAreaWithAddress, null, /*#__PURE__*/React.createElement(ShippingAreaTag, null, /*#__PURE__*/React.createElement(Ilocation, {
    width: "14px",
    height: "14px",
    fill: "gray900"
  }), /*#__PURE__*/React.createElement(ShippingAreaText, {
    type: "body-sm",
    color: "gray900"
  }, translations.firstLevelMenu.weather_field)), /*#__PURE__*/React.createElement(LocationText, {
    title: "".concat(address.City, ", ").concat(address.State),
    type: "subtitle-sm",
    color: "blue600"
  }, "".concat(address.City, ", ").concat(address.State))) : /*#__PURE__*/React.createElement(ShippingArea, null, /*#__PURE__*/React.createElement(Ilocation, {
    width: "16px",
    height: "16px",
    fill: "blue600"
  }), /*#__PURE__*/React.createElement(ShippingAreaButton, {
    type: "label-md",
    color: "blue600"
  }, translations.firstLevelMenu.weather_field))), showModal && /*#__PURE__*/React.createElement(ModalMobileMargins, null, /*#__PURE__*/React.createElement(AgroLocationWeatherModal, {
    isUserLogged: isLogged,
    apiGateway: apiGateway,
    onLogin: function onLogin() {
      return _onLogin();
    },
    onClose: function onClose() {
      return _onClose();
    },
    onChangeLocation: function onChangeLocation(newAddress) {
      return _onChangeLocation(newAddress);
    },
    country: language.slice(3),
    language: language,
    tagManager: tagManager,
    ctaCurrentLocationLabel: ctaCurrentLocationLabelModal
  })));
});
WeatherFieldZone.propTypes = {};
WeatherFieldZone.displayName = 'WeatherFieldZone';
export { WeatherFieldZone };
var firstSectionWidth = '196px';
var ScrollLock = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  html, body {\n    height: 100%;\n    overflow-y: hidden;\n    }\n"])));
var ShippingAreaContainer = styled.div.withConfig({
  displayName: "WeatherFieldZone__ShippingAreaContainer",
  componentId: "m7mm9e-0"
})(["height:32px;align-self:start;margin:0 16px;@media (min-width:", "){cursor:pointer;height:32px;width:", ";margin:0px;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint.xl;
}, firstSectionWidth);
var ShippingAreaWithAddress = styled.div.withConfig({
  displayName: "WeatherFieldZone__ShippingAreaWithAddress",
  componentId: "m7mm9e-1"
})(["width:fit-content;height:100%;padding-right:24px;@media (max-width:1200px){display:inline-flex;margin:auto;align-items:center;padding:0;}"]);
var ShippingAreaTag = styled.div.withConfig({
  displayName: "WeatherFieldZone__ShippingAreaTag",
  componentId: "m7mm9e-2"
})(["display:inline-flex;align-items:center;margin-right:4px;@media (min-width:", "){height:14px;margin-right:0;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint.xl;
});
var ShippingAreaText = styled(Text).withConfig({
  displayName: "WeatherFieldZone__ShippingAreaText",
  componentId: "m7mm9e-3"
})(["margin-left:4px;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;word-break:break-word;width:max-content;"]);
var LocationText = styled(Text).withConfig({
  displayName: "WeatherFieldZone__LocationText",
  componentId: "m7mm9e-4"
})(["overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;word-break:break-word;"]);
var ShippingArea = styled.div.withConfig({
  displayName: "WeatherFieldZone__ShippingArea",
  componentId: "m7mm9e-5"
})(["width:fit-content;display:flex;align-items:center;letter-spacing:-0.2px;cursor:pointer;height:32px;"]);
var ShippingAreaButton = styled(Text).withConfig({
  displayName: "WeatherFieldZone__ShippingAreaButton",
  componentId: "m7mm9e-6"
})(["margin-left:4px;"]);
var PopoverContainer = styled.div.withConfig({
  displayName: "WeatherFieldZone__PopoverContainer",
  componentId: "m7mm9e-7"
})(["width:100%;@media (min-width:", "){margin-left:8px;position:absolute;width:max-content;}@media (min-width:", "){margin-left:0px;margin-top:8px;position:absolute;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint.sm;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoint.xl;
});
var Popover = styled.div.withConfig({
  displayName: "WeatherFieldZone__Popover",
  componentId: "m7mm9e-8"
})(["padding:0;width:100%;margin:0;@media (min-width:", "){padding-top:8px;}@media (min-width:", "){padding-top:8px;padding-left:0px;width:fit-content;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoint.sm;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoint.xl;
});
var ModalMobileMargins = styled.div.withConfig({
  displayName: "WeatherFieldZone__ModalMobileMargins",
  componentId: "m7mm9e-9"
})(["@media (max-width:1200px){width:100%;background-color:red;padding-left:16px;padding-right:16px;}"]);